"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iAddressDetails = exports.iAddressDetailsPartial = void 0;
const t = require("io-ts");
const _addressDetailFields = {
    telephone: t.string,
    street: t.string,
    postalCode: t.string,
    country: t.string,
    city: t.string
};
const _partial = {
    id: t.number,
    fax: t.string,
    state: t.string,
    company: t.string,
    title: t.string
};
exports.iAddressDetailsPartial = t.partial(Object.assign(Object.assign({}, _addressDetailFields), _partial));
exports.iAddressDetails = t.intersection([
    t.interface(_addressDetailFields),
    t.partial(_partial)
]);
//# sourceMappingURL=addressDetails.js.map